<app-env-banner></app-env-banner>
<app-header></app-header>
<div class="main-content">
  <ng-container *ngIf="routeLoading$ | async; else routedContent">
    <app-page-loading eyebrow="Loading" [title]="(loadingTitle$ | async) || 'Loading BOLOARENA'"
      [message]="(loadingMessage$ | async) || 'We are loading the route and setting everything up.'"
      variant="detail"></app-page-loading>
  </ng-container>

  <ng-template #routedContent>
    <router-outlet></router-outlet>
  </ng-template>
</div>
<app-footer></app-footer>